export const UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT = 'UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT';
export const RESET_EMPLOYEE_BIDDING_RESULTS_REPORT = 'RESET_EMPLOYEE_BIDDING_RESULTS_REPORT';
